// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1aV7a","label":"CategoryService_label__2JOQR","location":"CategoryService_location__3qm8y"};